const routes = [
    {
        path: "/esl/attendance/admin/:sessionId",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "eslattendance_getattendanceswithsessionandweek"
        }
    }
]

export default routes;

